import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { Shop } from '@services/shops/shop.model';
import { TrackingPageDefaultValues } from '../../tracking-page.models';

@Component({
  selector: 'tracking-page-configuration',
  templateUrl: './tracking-page-configuration.component.html',
  styleUrls: ['./tracking-page-configuration.component.scss', '../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageConfigurationComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() trackingPageConfiguration: ShopPlugin.TrackingPage.Configuration;
  @Input() shop: Shop;

  currentThemeEditorUrl = '';
  couponCodeIndexToPreview: number = 0;
  displayMessageForUntrackedShipments: boolean = false;
  displayMessageWhenHandedOverToDifferentCarrier: boolean = false;
  trackingHandedOverToDifferentCarrierMetadata: boolean = false;
  unsuccessfulTrackingStatusColor: string = TrackingPageDefaultValues.settings.unsuccessfulTrackingStatusColor;
  showFutureSteps = true;
  previewState: 'settingPage' | 'searchPage' = 'settingPage';
  unsuccessfulTrackingStatusColorPreviewButtonState: boolean = false;
  showTrackingProgress = TrackingPageDefaultValues.widgets.simpleTracker.showFutureSteps;
  isGrayscale: boolean = false;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  initPreviewFieldsValueChanges() {
    this.isGrayscale = this.formGroup.get('settings.colorScheme')?.value === 'grayscale';

    this.formGroup.valueChanges.subscribe((values) => {
      this.displayMessageForUntrackedShipments = values.settings.displayMessageForUntrackedShipments;
      this.displayMessageWhenHandedOverToDifferentCarrier =
        values.settings.displayMessageWhenHandedOverToDifferentCarrier;
      this.trackingHandedOverToDifferentCarrierMetadata =
        this.shop?.metadata?.trackingHandedOverToDifferentCarrierMetadata;
      this.unsuccessfulTrackingStatusColor =
        values.settings.unsuccessfulTrackingStatusColor ??
        TrackingPageDefaultValues.settings.unsuccessfulTrackingStatusColor;
      this.showFutureSteps =
        values.widgets.simpleTracker.showFutureSteps || TrackingPageDefaultValues.widgets.simpleTracker.showFutureSteps;
      this.isGrayscale = values.settings.colorScheme === 'grayscale';
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shop?.currentValue) {
      this.currentThemeEditorUrl = `https://${this.shop.name}/admin/themes/current/editor`;
      this.trackingHandedOverToDifferentCarrierMetadata =
        this.shop?.metadata?.trackingHandedOverToDifferentCarrierMetadata;
    }

    if (changes.formGroup) {
      this.initPreviewFieldsValueChanges();
    }
  }
  setCouponCodeIndexToPreview(index: number) {
    this.couponCodeIndexToPreview = index;
  }

  setTrackingSearchPagePreviewSelected(value: boolean) {
    this.previewState = value === true ? 'searchPage' : 'settingPage';
    this.cdr.detectChanges();
  }

  previewSettingsClicked(event: Event) {
    event.stopPropagation();
    this.previewState = this.previewState === 'settingPage' ? 'searchPage' : 'settingPage';
    this.cdr.detectChanges();
  }

  previewUnsuccessfulTrackingStatusColorClicked(event: Event) {
    event.stopPropagation();
    this.unsuccessfulTrackingStatusColorPreviewButtonState = !this.unsuccessfulTrackingStatusColorPreviewButtonState;
    this.cdr.detectChanges();
  }
}
